/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_Order_IdInputs */

const en_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy order ID`)
};

const id_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salin ID pesanan`)
};

const ms_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salin ID pesanan`)
};

const ca_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia l'ID de comanda`)
};

const cs_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopírovat ID objednávky`)
};

const da_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopier ordre-ID`)
};

const de_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestell-ID kopieren`)
};

const et_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopeeri tellimuse ID`)
};

const es_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar ID del pedido`)
};

const fr_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier l’ID de commande`)
};

const hr_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiraj ID narudžbe`)
};

const it_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia ID ordine`)
};

const lv_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopēt pasūtījuma ID`)
};

const lt_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopijuoti užsakymo ID`)
};

const hu_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendelési azonosító másolása`)
};

const nl_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestel-ID kopiëren`)
};

const nb_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopier ordre-ID`)
};

const pl_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skopiuj identyfikator zamówienia`)
};

const pt_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar ID do pedido`)
};

const ro_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiază ID-ul comenzii`)
};

const sk_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skopírovať ID objednávky`)
};

const sl_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiraj ID naročila`)
};

const fi_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopioi tilaustunnus`)
};

const sv_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiera order-ID`)
};

const vi_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sao chép ID đơn hàng`)
};

const tr_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sipariş kimliğini kopyala`)
};

const el_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αντιγραφή ID παραγγελίας`)
};

const bg_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копиране на ID на поръчката`)
};

const ru_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопировать ID заказа`)
};

const sr_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копирај ID поруџбине`)
};

const uk_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копіювати ID замовлення`)
};

const ka_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`შეკვეთის ID-ის კოპირება`)
};

const hi_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑर्डर ID कॉपी करें`)
};

const th_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คัดลอกรหัสคำสั่งซื้อ`)
};

const ko_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주문 ID 복사`)
};

const zh_tw_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複製訂單 ID`)
};

const ja_copy_order_id = /** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注文 ID をコピー`)
};

/** @type {(inputs: Copy_Order_IdInputs) => LocalizedString} */
const zh_copy_order_id = en_copy_order_id;

/**
* | output |
* | --- |
* | "Copy order ID" |
*
* @param {Copy_Order_IdInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const copy_order_id = /** @type {((inputs?: Copy_Order_IdInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_Order_IdInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_copy_order_id(inputs)
	if (locale === "ms") return ms_copy_order_id(inputs)
	if (locale === "ca") return ca_copy_order_id(inputs)
	if (locale === "cs") return cs_copy_order_id(inputs)
	if (locale === "da") return da_copy_order_id(inputs)
	if (locale === "de") return de_copy_order_id(inputs)
	if (locale === "et") return et_copy_order_id(inputs)
	if (locale === "es") return es_copy_order_id(inputs)
	if (locale === "fr") return fr_copy_order_id(inputs)
	if (locale === "hr") return hr_copy_order_id(inputs)
	if (locale === "it") return it_copy_order_id(inputs)
	if (locale === "lv") return lv_copy_order_id(inputs)
	if (locale === "lt") return lt_copy_order_id(inputs)
	if (locale === "hu") return hu_copy_order_id(inputs)
	if (locale === "nl") return nl_copy_order_id(inputs)
	if (locale === "nb") return nb_copy_order_id(inputs)
	if (locale === "pl") return pl_copy_order_id(inputs)
	if (locale === "pt") return pt_copy_order_id(inputs)
	if (locale === "ro") return ro_copy_order_id(inputs)
	if (locale === "sk") return sk_copy_order_id(inputs)
	if (locale === "sl") return sl_copy_order_id(inputs)
	if (locale === "fi") return fi_copy_order_id(inputs)
	if (locale === "sv") return sv_copy_order_id(inputs)
	if (locale === "vi") return vi_copy_order_id(inputs)
	if (locale === "tr") return tr_copy_order_id(inputs)
	if (locale === "el") return el_copy_order_id(inputs)
	if (locale === "bg") return bg_copy_order_id(inputs)
	if (locale === "ru") return ru_copy_order_id(inputs)
	if (locale === "sr") return sr_copy_order_id(inputs)
	if (locale === "uk") return uk_copy_order_id(inputs)
	if (locale === "ka") return ka_copy_order_id(inputs)
	if (locale === "hi") return hi_copy_order_id(inputs)
	if (locale === "th") return th_copy_order_id(inputs)
	if (locale === "ko") return ko_copy_order_id(inputs)
	if (locale === "zh") return zh_copy_order_id(inputs)
	if (locale === "zh-tw") return zh_tw_copy_order_id(inputs)
	if (locale === "ja") return ja_copy_order_id(inputs)
	return en_copy_order_id(inputs)
});